import { useState, useEffect, useRef, useContext } from 'react'
import axios from 'axios'
import { loadingContext, urlValue, unfolder, openAlert } from '../lib'
// import { loadingContext, projectContext, urlValue, unfolder, onImportExcelAsync,openAlert } from '../../lib'
import '../styles/sideVoice.scss'
import { Tooltip } from 'react-tooltip'
import { Alerts } from './common/Alerts'
import FormData from 'form-data';

export function NewVoice({ selectedVoice, refresh, setRefresh, update}) {
  
  const [isRecording, setIsRecording] = useState(false);
  const [recordings, setRecordings] = useState([]);
  const [projects, setProjects] = useState([]);
  const [active, setActive] = useState(0);
  const [loading, setLoading] = useContext(loadingContext)
  const [alert, setAlert] = useState({title: '', visible: false})
  const mediaRecorderRef = useRef(null);
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [name, setName] = useState('Customizable Voice Name');
  const [editName, setEditName] = useState(false)
  const [audioFile, setAudioFile] = useState(null);
  const [blobTemp, setBlobTemp] = useState(null);
  const [email, setEmail] = useState('');
  const emailInput = useRef()
  const [phrases, setPhrases] = useState([])
  // const phrases = [
  //   "Hola, ¿cómo estás?",
  //   "¿Qué tal tu día?",
  //   "¿Qué opinas sobre el clima?",
  //   "Cuéntame algo sobre ti.",
  //   // Agrega más frases aquí si lo deseas
  // ];
  let conteo = 0
  ///ENTRENAMIENTO MODELO
  const subscriptionKey = 'f381dc7eec66451db1d50d6f50b23788';
  const region = 'eastus';
  const endpoint = `https://eastus.api.cognitive.microsoft.com`;

  const [datasetFile, setDatasetFile] = useState(null);
  const [datasetId, setDatasetId] = useState('');
  const [modelId, setModelId] = useState('');
  const [textToSynthesize, setTextToSynthesize] = useState('');


  const handleFileChange2 = (event) => {
    setDatasetFile(event.target.files[0]);
  };

  const handleUploadDataset = async () => {
    console.log("Ingreso")
    if (recordings.length > 0) {
      // const result = await uploadDataset('customVoiceDataset', datasetFile);
      
      const url = `${endpoint}/speechtotext/v3.0/datasets`;
      const form = new FormData();
      form.append('name', 'customVoiceDataset');
      form.append('locale', 'es-US');
      form.append('description', 'Training dataset for custom voice');
      // form.append('files', datasetFile);

      recordings.forEach((file, index) => {
        form.append(`files[${index}]`, file);
      });
      console.log(form)
      const response = await axios.post(url, form, {
        headers: {
          'Ocp-Apim-Subscription-Key': subscriptionKey,
          // 'Content-Type': 'multipart/form-data'
        },
      });
    
      setDatasetId(response.data.datasetId); // Suponiendo que la respuesta contiene el ID del dataset
    }    
  };

  const handleTrainModel = async () => {
    if (datasetId) {
      // const result = await trainModel(datasetId);
      const url = `${endpoint}/speechtotext/v3.0/models`;
      const data = {
        datasets: [datasetId],
        locale: 'en-US',
        name: 'customVoiceModel',
        description: 'Custom voice model training',
      };

      const response = await axios.post(url, data, {
        headers: {
          'Ocp-Apim-Subscription-Key': subscriptionKey,
          'Content-Type': 'application/json',
        },
      });

      setModelId(response.data.modelId); // Suponiendo que la respuesta contiene el ID del modelo
    }
  };
  
  const handleDeployModel = async () => {
    if (modelId) {
      // await deployModel(modelId);
      const url = `${endpoint}/speechtotext/v3.0/models/${modelId}/deploy`;

      const response = await axios.post(url, {}, {
        headers: {
          'Ocp-Apim-Subscription-Key': subscriptionKey,
          'Content-Type': 'application/json',
        },
      });

      console.log(response.data);
    }
  };

  const changeLanguage = async (e) => { 
    // console.log(e.target.value)
    await getPhrases(e.target.value)
  }
  

  const getPhrases = async (language) => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
    
    const res = await axios.post(
      `${urlValue}/studio/project/phrasescustom`,
      { language: language
      },
      {
        headers: {
          'access-token': token,
          user: id
        },
      })

      if (res.status === 200) {
        // console.log(res.data?.data)
        setPhrases(res.data?.data)
      }
  };
  ///FINAL
  useEffect(() => {
    getPhrases('EN')
    if (selectedVoice?.id) {
      let id_user = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
      let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
      setLoading(true)
      axios({
        method: 'get',
        url: `${urlValue}/studio/voice/${selectedVoice.id}`,
        headers: {
          'user': id_user,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      })
        .then(async function (response) {
          const listBlobs = []
          // setRecordings([])
          setName(response.data.name)
          setEmail(response.data.email)
          setActive(response.data.active)
          for (const url of response.data.listaArchivos) {
            const response_url = await fetch(url);
            const blob = await response_url.blob();
            listBlobs.push(blob)
          }
          setRecordings(listBlobs);
          // setListVoices(response?.data || [])
          setLoading(false)

        })
        .catch(function (error) {
          console.log(error)
          setLoading(false)
        })
    }
    else {
      cleanForm()
    }
  }, [selectedVoice])

  useEffect(() => {
    console.log("Consulta projectos")
    let id_user = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    setLoading(true)
    axios({
      method: 'get',
      url: `${urlValue}/studio/voice/projects`,
      headers: {
        'user': id_user,
        'access-token': token,
        'Content-Type': 'application/json',
      },
    })
      .then(function (response) {
        console.log(response?.data?.projects)
        setProjects(response?.data?.projects || [])
        // setListVoices(response?.data || [])
        setLoading(false)

      })
      .catch(function (error) {
        console.log(error)
        setLoading(false)
      })
  }, [active])

  const handleCancel = () => {
    cleanForm()
    update();
  }

  const cleanForm = () => {
    setName('Customizable Voice Name')
    setEmail('')
    setRecordings([])
    setActive(0)
  }

  const handleFileChange = async (audioFile) => {
    const formData = new FormData();
    conteo = conteo + 1
    const nameFile = "record" + conteo.toString() + ".wav"
    formData.append('audio', audioFile, nameFile);
    let id_user = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    
    await axios.post(`${urlValue}/studio/voice`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'name': name,
        'email': email, 
        phrase_number: 2,
        'user': id_user,
        'access-token': token,
        'locale': 'es-MX'
      }
    })
    .then(response => {
      console.log('Respuesta del servidor:', response.data);
      update()
      openAlert('#alert-ac', () => {setAlert({title: 'Voice have been create properly!', visible: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
    })
    .catch(error => {
      console.error('Error al subir el archivo:', error);
    });
  };

  const handleUpload = async () => {
    // console.log(recordings)
    for (const record of recordings) {
      await handleFileChange(record)
    }
  };

  const handleNextSlide = () => {
    setCurrentPhraseIndex((prevIndex) => (prevIndex + 1) % phrases.length);
  };

  const handlePreviousSlide = () => {
    setCurrentPhraseIndex((prevIndex) =>
      prevIndex === 0 ? phrases.length - 1 : prevIndex - 1
    );
  };

  const currentPhrase = phrases[currentPhraseIndex]?.phrase;
  const currentId = phrases[currentPhraseIndex]?.id;

  const onRecording = () => {
    if (!isRecording){
      navigator.mediaDevices.getUserMedia({ audio: true })
      .then(stream => {
        const mediaRecorder = new MediaRecorder(stream);
        mediaRecorderRef.current = mediaRecorder;

        const chunks = [];
        mediaRecorder.ondataavailable = event => {
          chunks.push(event.data);
        };

        mediaRecorder.onstop = () => {
          const blob = new Blob(chunks, { type: 'audio/wav' });
          // setRecordings([...recordings, blob]);
          setBlobTemp(blob)
          const audioUrl = URL.createObjectURL(blob);
          const audio = new Audio(audioUrl);
          
          audio.onloadedmetadata = () => {
            setDuration(5)
            
            console.log(audio, audio.duration)
            // URL.revokeObjectURL(audio.src); // Liberar recursos
          };
        };

        mediaRecorder.start();
        setIsRecording(true);
      })
      .catch(err => console.error('Error al obtener acceso al micrófono: ', err));
    }
    else {
      if (mediaRecorderRef.current && isRecording) {
        mediaRecorderRef.current.stop();
        setIsRecording(false);
      }
    }
    
  };

  const saveAudio = () => {
    if (!blobTemp) {
      alert('No hay audio que grabar')
    }
    else {
      setRecordings([...recordings, blobTemp]);
      setBlobTemp(null)
      handleNextSlide()
    }
    
  }

  const [duration, setDuration] = useState(0)
  const [currentTime, setCurrentTime] = useState(0);
  const [progress, setProgress] = useState(0);
  // Simulación del tiempo transcurrido (reproducir un audio)
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentTime(prevTime => (prevTime < duration ? prevTime + 1 : 0));
  //     setProgress((currentTime / duration) * 100)
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, [duration]);

  const playRecording = (blob) => {
    if (blob != null){
      const audioUrl = URL.createObjectURL(blob);
      const audio = new Audio(audioUrl);
      audio.play();
    }    
  };

  const [isOpen, setIsOpen] = useState(false); // Estado para controlar si el cuadro de selección está abierto o cerrado
  const [selectedOptions, setSelectedOptions] = useState([]); // Estado para almacenar las opciones seleccionadas

  // Función para manejar cambios en las opciones seleccionadas
  const handleOptionChange = (e) => {
    const value = e.target.value;
    if (selectedOptions.includes(value)) {
      setSelectedOptions(selectedOptions.filter(option => option !== value));
    } else {
      setSelectedOptions([...selectedOptions, value]);
    }
  };

  // Función para manejar clic en el cuadro de selección
  const toggleSelectBox = () => {
    setIsOpen(!isOpen);
  };

  const [audioSrc, setAudioSrc] = useState('');
  // const [currentTime, setCurrentTime] = useState(0);

  const playAudio = () => {
    console.log("blobTemp", blobTemp)
    playRecording(blobTemp)
    let playblob = true
    let time = 0
    setInterval(() => {
      if (playblob && time < duration){
        console.log("duration", time, "Aca", currentTime, duration)
        time = time + 1
        setCurrentTime(time + 1);
        setProgress((time / duration) * 100)
      }
      else {
        setCurrentTime(0) 
        playblob = false
      }
      
    }, 1000)

    // clearInterval(0)
  };

  
  const handleContenidoChange = (e) => {
    setName(e.target.value)
  }

  const handleEditName = (e) => {
    setEditName(true)
  }

  const removeRecording = (index, phrase) => {
    console.log(index, phrase)
    setRecordings(prev => prev.filter((e, i) => i !== index))
  }

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  return (
    <div id="voices">
      <div className="Voice">
        <div className="  scroll-internal-intents ">
          <div className="IntTitle">
            {/* <h2>Create Customizable Voice</h2> */}
            <input type="text" value={name}  onChange={handleContenidoChange} disabled={!editName}>
              
            </input>
            <button onClick={handleEditName}>
              <img src="/icons/edit-icon.svg" alt="Edit name" />
            </button>
          </div>
          <div className="select" style={{ maxWidth: 183, marginTop: 5, }}>
            <select id="language" className="w-100 select-nesting" style={{ backgroundPositionX: "98%" }} onChange={changeLanguage}>
              <option value="EN">English</option>
              <option value="ES">Spanish</option>
            </select>
          </div>
          <div className="Labels">
            <label>When you are ready to read the following sentence, please record</label>
          </div>
          <div className='Phrases'>
            <div>
              <h2>&#123;Recording #{currentId}&#125;</h2>
            </div>
            <div>
              <p>{currentPhrase}</p>
            </div>
            <div>
              <button className='buttonRecording' onClick={onRecording}>
                { isRecording ?
                  <img src="/icons/record-btn-hover.png" alt="Start Recording" />
                  :
                  <img src="/icons/record-btn.png" alt="Stop Recording" />
                }
              </button>            
            </div>
            <div className="Labels">
              <label>Press start the icon to start/stop recording or use Enter or Space Bar</label>
            </div>
            <div className='reproduceAudio'>
              <button onClick={playAudio}>
                <img src="/icons/play-icon.svg" alt="Start Recording" />
              </button>
              <button >
                <img src="/icons/pause-icon.svg" alt="Start Recording" />
              </button>
              <div className="timer">{formatTime(currentTime)}</div>
              <progress class="custom-progress" max={duration} value={currentTime}></progress>
              <div className="timer">{formatTime(duration)}</div>
              {/* <div className="progress-dot" style={{ left: `${progress}%` }} /> */}
            </div>
            <div>
              <button className='create btn-bottom save-next' onClick={saveAudio}>Save and Next</button>            
            </div>
          </div>         
          {/* scroll-panel-left */}
          <div className="form_voice_create" style={{ paddingRight: 22, width: '100% !important', borderTop: '1px solid #707070', }}>
            {recordings.map((blob, index) => (

                <div className="element" key={index}>
                  <div className="listAudios">
                    <div className='list-color' >Record # {index + 1}</div>
                  </div>
                  <div className="options_container">
                    <img
                      id={`play-voice-${index}`}
                      src="/icons/play-icon.svg"
                      alt="play"
                      onClick={() => playRecording(blob)}
                    />
                    {/* <Tooltip anchorSelect={`#play-tp-${index}`} content={`Play`} place="top" /> */}
                    <div id={`delete-voice-${index}`} className="more" onClick={() => removeRecording(index, blob)}>
                      <img src="/icons/trash.png" alt="trash" />
                    </div>
                    {/* <Tooltip anchorSelect={`#delete-audio-${index}`} content={`Delete`} place="top" /> */}
                  </div>

                </div>
              ))}
          </div>
          <div className="multi-select" style={{ paddingRight: 22, width: '100% !important', borderTop: '1px solid #707070', }}>
            <span style={{ fontSize: 20 }} className="title-crud">Projects Assignments:</span>
            <div className="select-box" style={{ opacity: active == 0 ? 0.6 : 1, pointerEvents: active == 0 ? 'none' : 'auto' }} onClick={toggleSelectBox}>
              <div className="selected-options">
                {selectedOptions.length === 0 ? "" : selectedOptions.join(", ")}
              </div>
              <i className={`arrow-icon ${isOpen ? 'up' : 'down'}`}></i>
            </div>
            {isOpen && (
              <div className="options-container">
                {projects.map((option, index) => (
                  <label key={index} className="option">
                    <input type="checkbox" value={option.name} onChange={handleOptionChange} checked={option.check_value} />
                    {option.name}
                  </label>
                ))}
              </div>
            )}
          </div>

          <div className="disclaimer-audio">
            <label>When you have <strong>30 audio Records</strong>, you can use the email input fiel below to send an email where you will receive a notification when the proccessing of the audio records is complete</label>
          </div>
          <div className="addEmail">
            <span style={{ fontSize: 20 }} className="title-crud">Email:</span>
            <input
              id='train-tp'
              type="text"
              placeholder='Enter the Email'
              ref={emailInput}
              className='input-data'
              onChange={e => (setEmail(e.target.value))}
            />
          </div>
          <div className="buttons">
            <button id='cancel-tp' className="create btn-bottom btn-bottom-cancel" onClick={(handleCancel)} style={{ minWidth: "auto" }}>Cancel</button>
            <Tooltip anchorSelect="#cancel-tp" content={"Cancel creation"} place={"top"} />

            <button id='save-tp' className="create btn-bottom btn-bottom-create" onClick={(handleUpload)} style={{ marginLeft: 10, minWidth: "auto" }}>Create</button>
            <Tooltip anchorSelect="#save-tp" content={"Save changes"} place={"top"} />            
          </div>
          <div>
            <button id='upload-tp' className="create btn-bottom btn-bottom-create" onClick={(handleUploadDataset)} style={{ marginLeft: 10, minWidth: "auto" }}>Upload</button>
            <button id='train-tp' className="create btn-bottom btn-bottom-create" onClick={(handleTrainModel)} style={{ marginLeft: 10, minWidth: "auto" }}>Train</button>
            <button id='deploy-tp' className="create btn-bottom btn-bottom-create" onClick={(handleDeployModel)} style={{ marginLeft: 10, minWidth: "auto" }}>Deploy</button>
          </div>
        </div>
        
        {/* <div>
          <button >Cancel</button>
          <button onClick={handleUpload}>Create</button>
        </div> */}
      </div>
      {alert.visible && <Alerts id="alert-ac" title={alert.title} />}
    </div>
  );
}
